import AddIcon from "@mui/icons-material/Add";
import UIIconButton from "../ui-controls/icon-button";
import { useEffect, useState } from "react";
import { removeEmptyKeys } from "@/modules/crm/settings/components/details/content/custom-fields/helper.js";
import Lead_signalr from "@/modules/crm/leads/signalr-constants";
import useRoles from "@/hooks/useRoles";
import FieldModal from "@/modules/crm/settings/components/details/content/custom-fields/add-field";
import useSignalRClient from "@/services/signal-R/signalr-hubs";
import guid from "guid";
import OnInitHub from "@/services/signal-R/on-receive-hook";
import { success, toastMsg } from "@/services/variables";
import { useSelector } from "react-redux";
import useManageLead from "@/hooks/leads/useManageLead";
import { getAllRequests } from "@/store/slices/requests";
import { toast } from "react-toastify";

const {
  hubName,
  InvokeMethodNames: { createCustomField },
  onReceiveMethodNames: { onCreateCustomField },
} = Lead_signalr;

const resultMethods = {
  [onCreateCustomField]: { successOperation: "saved" },
};
let methodKeys = Object.keys(resultMethods);

const AccordionHeaderRight = (props) => {
  // signalr connection for lead status add/update/delete/reorder
  const { statuses, RTC } = useSignalRClient({ hubName: hubName });
  const leadhub = RTC[hubName];
  const [openModal, setOpenModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const permission = useRoles("customField").getPermission;
  const requests = useSelector(getAllRequests);
  const { clearStateByMethods } = OnInitHub();
  const { getCustomFields, fetchLeadUpdateFields } = useManageLead();

  const onCloseModal = (resetForm) => {
    setOpenModal(false);
    if (openModal || resetForm) {
      setFormData(null);
    }
  };
  const onSave = (value) => {
    if (statuses[hubName] && leadhub) {
      let methodName = createCustomField;
      let payload = createPayload(value);
      console.log("payload ::", payload);
      onSend(methodName, payload);
    }
  };

  const createPayload = (data) => {
    let payload = {
      leadCustomFields: {
        ...removeEmptyKeys(data),
      },
      requestId: guid.raw(),
    };
    return payload;
  };

  const onSend = (methodName, payload) => {
    setSubmitting(true);
    leadhub
      .invoke(methodName, payload)
      .then((res) => {
        setSubmitting(false);
        logIt("log", "on add custom field callback::", res);
        setOpenModal(false);
      })
      .catch((err) => {
        setSubmitting(false);
        setOpenModal(false);
        console.log("error ::", err);
      });
  };

  useEffect(() => {
    // response methods signal_R listeners for lead status
    let findedKey = methodKeys.find((key) => key in requests && requests[key]);
    if (findedKey) {
      // this will only run if any request with same method have data in it
      // no need for reorder listener
      let response = requests[findedKey];
      let successOperation = resultMethods[findedKey]?.successOperation;
      responseHandler(response, successOperation, findedKey);
      clearStateByMethods(methodKeys);
    }
  }, [requests[onCreateCustomField]]);

  const responseHandler = (response, successOperation = "", methodName) => {
    if (response.isSuccess) {
      onSuccess(successOperation);
    } else {
      let msg = response.errors[0];
      onError(msg);
    }
  };

  const onSuccess = (operation, refetch = false) => {
    setFormData(null);
    setSubmitting(false);
    toast.success(success.saveSuccess("Custom Field", operation));
    getCustomFields();
    fetchLeadUpdateFields();
  };

  const onError = (errorMsg) => {
    setSubmitting(false);
    toast.error(toastMsg.errors.customError(errorMsg));
  };

  return (
    <>
      <UIIconButton
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setOpenModal(true);
        }}
        color="inherit"
        title={
          <AddIcon
            // color="primary"
            fontSize="small"
          />
        }
        variant="outlined"
        style={{ padding: "4px" }}
      />
      {/* Add Field Modal */}
      <FieldModal
        open={openModal}
        onSave={onSave}
        onClose={onCloseModal}
        loading={submitting}
        data={null}
        title="Add field in lead form"
      />
    </>
  );
};

export default AccordionHeaderRight;
